module.exports = __webpack_public_path__ + "static/media/dianqibu.20896578.png";